import React from 'react';
import PropTypes from 'prop-types';

const CrashedFile = () => {
  return (
    <svg
      width="67"
      height="80"
      viewBox="0 0 67 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.9548 19.2547L37.3541 31.8398L36.2804 47.066L42.5699 61.4951C42.8205 62.0714 42.8282 62.7245 42.5895 63.3056L36.2804 78.6896H64.6664C64.9728 78.6897 65.2763 78.6295 65.5594 78.5126C65.8425 78.3956 66.0997 78.2241 66.3164 78.008C66.5331 77.7918 66.705 77.5351 66.8223 77.2526C66.9396 76.9701 67 76.6673 67 76.3615V16.7869C67 16.4768 66.8754 16.1793 66.6549 15.9606L52.198 1.63555C51.9795 1.41909 51.6842 1.29757 51.3763 1.29749H36.2797L34.9212 18.6379C34.9051 18.844 34.9163 19.0514 34.9548 19.2547Z"
        fill="white"
      />
      <path
        opacity="0.8"
        d="M34.9548 19.2547L37.3541 31.8398L36.2804 47.066L42.5699 61.4951C42.8205 62.0714 42.8282 62.7245 42.5895 63.3056L36.2804 78.6896H64.6664C64.9728 78.6897 65.2763 78.6295 65.5594 78.5126C65.8425 78.3956 66.0997 78.2241 66.3164 78.008C66.5331 77.7918 66.705 77.5351 66.8223 77.2526C66.9396 76.9701 67 76.6673 67 76.3615V21.7869C67 21.4768 66.8754 21.1793 66.6549 20.9606L47.1877 1.63555C46.9692 1.41909 46.6739 1.29757 46.366 1.29749H36.2797L34.9212 18.6379C34.9051 18.844 34.9163 19.0514 34.9548 19.2547Z"
        fill="#CFDAE1"
      />
      <path
        opacity="0.4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.0938 1V18.227C46.0938 20.067 47.5888 21.56 49.4336 21.56H66.8064"
        fill="#90A0A9"
      />
      <path
        d="M0.202904 5.36773L6.52952 77.6813C6.55608 77.9859 6.64252 78.2823 6.78389 78.5536C6.92526 78.8248 7.1188 79.0656 7.35345 79.2622C7.5881 79.4587 7.85927 79.6072 8.15147 79.6991C8.44367 79.791 8.75117 79.8246 9.05641 79.7979L35.1801 77.5124L40.137 61.67C40.2301 61.372 40.2622 61.0584 40.2315 60.7478C40.2007 60.4372 40.1076 60.136 39.9578 59.862L32.4305 46.0837L32.047 31.2121C32.0443 31.117 32.0304 31.0221 32.0048 30.9304L28.5171 18.3939C28.4893 18.2932 28.4753 18.1892 28.4753 18.0848L28.447 0.559736L2.32392 2.84521C1.70758 2.89913 1.13786 3.19519 0.740091 3.66825C0.342322 4.14132 0.149091 4.75264 0.202904 5.36773Z"
        fill="white"
      />
      <path
        opacity="0.8"
        d="M0.202904 5.36773L6.52952 77.6813C6.55608 77.9859 6.64252 78.2823 6.78389 78.5536C6.92526 78.8248 7.1188 79.0656 7.35345 79.2622C7.5881 79.4587 7.85927 79.6072 8.15147 79.6991C8.44367 79.791 8.75117 79.8246 9.05641 79.7979L35.1801 77.5124L40.137 61.67C40.2301 61.372 40.2622 61.0584 40.2315 60.7478C40.2007 60.4372 40.1076 60.136 39.9578 59.862L32.4305 46.0837L32.047 31.2121C32.0443 31.117 32.0304 31.0221 32.0048 30.9304L28.5171 18.3939C28.4893 18.2932 28.4753 18.1892 28.4753 18.0848L28.447 0.559736L2.32392 2.84521C1.70758 2.89913 1.13786 3.19519 0.740091 3.66825C0.342322 4.14132 0.149091 4.75264 0.202904 5.36773Z"
        fill="#CFDAE1"
      />
    </svg>
  );
};

export default CrashedFile;
